import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Link, Theme, Typography } from '@mui/material';
import { CiCdFields } from '../../types/issues-types';
import { isValidHttpUrl } from '../../../../common/common-utils';

const IssueCiCdFields: FC<
  React.PropsWithChildren<IssueCiCdFieldsProps>
> = props => {
  const { classes } = useStyles();
  const { fields } = props;
  return (
    <div className={classes.container}>
      {Object.keys(fields).map(
        key =>
          fields[key] !== null &&
          fields[key] !== undefined && (
            <div className={classes.item} key={key}>
              <Typography
                variant='caption'
                color='text.secondary'
                sx={{ textTransform: 'capitalize' }}>
                {key.split(/(?=[A-Z])/).join(' ')}
              </Typography>
              {isValidHttpUrl(fields[key]) ? (
                <Link variant='caption' href={fields[key] as string}>
                  {fields[key]}
                </Link>
              ) : (
                <Typography variant='caption' color='text.primary'>
                  {fields[key].toString()}
                </Typography>
              )}
            </div>
          ),
      )}
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  item: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
  },
}));

export interface IssueCiCdFieldsProps {
  fields: CiCdFields;
}

export default IssueCiCdFields;
